import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MergeAcceptPopupComponent } from '../merge-accept-popup/merge-accept-popup.component';
import { MergeRejectPopupComponent } from '../merge-reject-popup/merge-reject-popup.component';
import { FcPopupComponent } from '../../reach-defaulter/fc-popup/fc-popup.component';
import { AreYouUpdatedResponse, FcInfo } from '../../services/raintree/interfaces/are-you-updated.interface';
import { AreYouUpdatedService } from '../../services/raintree/Transmission/are-you-updated.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderComponent } from '../../common-component/loader/loader.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-merge-fc-popup',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, LoaderComponent, ClipboardModule, MatTooltipModule],
  templateUrl: './merge-fc-popup.component.html',
  styleUrl: './merge-fc-popup.component.scss',
})
export class MergeFcPopupComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<MergeFcPopupComponent>,
    private toaster: ToastrService,
    private areYouUpdatedService: AreYouUpdatedService
  ) { }
  isLoading: boolean = false
  fcDetails: any = []
  ngOnInit(): void {
    console.log(this.data);
  }
  rejectionDatum() {
    const dialogRef = this.dialog.open(MergeRejectPopupComponent, {
      data: {
        data: this.data.fc,
        memKey: this.data.memData.memkey,
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value) this.dialogRef.close(true);
    });
  }
  acceptDialogue() {
    const dialogRef = this.dialog.open(MergeAcceptPopupComponent, {
      data: { fc: this.data.fc, memKey: this.data.memData.memkey },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value) this.dialogRef.close(true);
    });
  }
  onFcClick(fc: any) {
    this.isLoading = true
    let reqData: any = { fc: fc }
    this.areYouUpdatedService.getFcInfo(reqData).subscribe({
      next: (response: any) => {
        console.log(response);
        let address = response.data[0].addressFields.fullAddress
        this.fcDetails = response.data.filter(
            (user: any) => user.memFullName != null
          )
          .map((user: any) => ({
            name: user.memFullName,
            lid: user.lastIvDate,
            // address: user.addressFields
          }));

        if (this.fcDetails.length > 0) {
          const dialogRef = this.dialog.open(FcPopupComponent, {
            data: { fcData: this.fcDetails, fc: fc, fcMerge: true, address: address },
          });
        }
        this.isLoading = false;

      },
      error: (error: any) => {
        this.isLoading = false;
        this.toaster.error(error);
      },
    });
  }
}
